import { render, staticRenderFns } from "./EmailEventsDetailFilter.vue?vue&type=template&id=67dd7f84&"
import script from "./EmailEventsDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./EmailEventsDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports